import React, {useContext, useState, ReactNode, useMemo } from 'react';

interface LocationContextType {
  loadedLocation: GeolocationPosition | null;
  setIsLocationLoaded: (location: GeolocationPosition | null) => void;
}

const LocationContext = React.createContext<LocationContextType | null>(null);

export const LocationProvider: React.FC<{children: React.ReactNode}>  = ({ children }) => {
  const [loadedLocation, setLoadedLocation] = useState<GeolocationPosition | null>(null);

  const setIsLocationLoaded = (location: GeolocationPosition | null) => {
    setLoadedLocation(location);
  };
  
  const value = useMemo(() => ({ loadedLocation, setIsLocationLoaded }), [loadedLocation]);

  return <LocationContext.Provider value={value}>{children}</LocationContext.Provider>;
};

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
};